import { request } from "../utils/request.js"


export const order_addNew = (pojo, args) => request({
    url: 'order/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const order_findByPageForManage = (pojo, args) => request({
    url: 'order/findByPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const order_findVoById = (id, args) => request({
    url: 'order/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/order.js